import DeltaCounts from "components/DeltaCounts";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import { getModulePullRequestSingleRun } from "../../../helpers";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestDeltaCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  const singleRun = getModulePullRequestSingleRun(pullRequest.runs);
  const delta = singleRun?.delta;

  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!delta && <TableCellEmpty />}

      {!!delta && (
        <DeltaCounts
          size="small"
          align="start"
          variant="flexible"
          direction="column"
          delta={delta}
        />
      )}
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestDeltaCell;
